import AssigneeRemoveButton from './AssigneeRemoveButton'
export default AssigneeRemoveButton



// WEBPACK FOOTER //
// ./src/components/AssigneeRemoveButton/index.js